var map = {
	"./assessments/en.json": 46613,
	"./assessments/it.json": 71737,
	"./certificate/en.json": 80994,
	"./certificate/it.json": 28380,
	"./community/en.json": 1090,
	"./community/it.json": 91761,
	"./errors/en.json": 8796,
	"./errors/it.json": 94458,
	"./fields/en.json": 27774,
	"./fields/it.json": 39395,
	"./fullScreenEditor/en.json": 40862,
	"./fullScreenEditor/it.json": 21312,
	"./global/en.json": 65044,
	"./global/it.json": 61637,
	"./home/en.json": 9116,
	"./home/it.json": 2137,
	"./invite/en.json": 85203,
	"./invite/it.json": 68970,
	"./journal/en.json": 37414,
	"./journal/it.json": 55876,
	"./moodsAndReactions/en.json": 30647,
	"./moodsAndReactions/it.json": 73749,
	"./multime/en.json": 45889,
	"./multime/it.json": 10916,
	"./notifications/en.json": 47165,
	"./notifications/it.json": 66472,
	"./onboarding/en.json": 89944,
	"./onboarding/it.json": 15858,
	"./privacy/en.json": 98682,
	"./privacy/it.json": 31348,
	"./profile/en.json": 31524,
	"./profile/it.json": 2318,
	"./programs/en.json": 31455,
	"./programs/it.json": 79266,
	"./services/en.json": 79247,
	"./services/it.json": 18934,
	"./stepper/en.json": 63511,
	"./stepper/it.json": 66122,
	"./streams/en.json": 66014,
	"./streams/it.json": 6504,
	"./validation/en.json": 47620,
	"./validation/it.json": 63411,
	"./webinars/en.json": 25839,
	"./webinars/it.json": 50814,
	"./widgets/en.json": 51381,
	"./widgets/it.json": 22491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3631;